import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { TaskReserveCreateInterface } from '../definitions/task-reserve-create-interface';
import { TaskReserveCreateRequestInterface } from '../definitions/task-reserve-create-request-interface';

@Injectable()
export class TaskReserveCreateService {

  private apiUrl: string = environment.rest.apiV2Url;

  public constructor(private client: HttpClient) {}

  public create(taskId: string, data: TaskReserveCreateRequestInterface): Observable<TaskReserveCreateInterface> {
    const url = `${this.apiUrl}/tasks/${taskId}/reserves`;

    return this.client.post<TaskReserveCreateInterface>(url, data).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
